export default __webpack_public_path__ + "static/media/cwPosLogo.f20ed4d8.png";